import Bank from './bank.jpg';
function Home(){
    return(<>
    <center style={{paddingTop:"50px"}}>
   <img 
  src={Bank} 
  alt="Bank building"
  style={{ 
    width: "70%",     
    maxWidth: "600px", 
    borderRadius: "10px", 
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)" 
  }} 
/>
    </center>
    </>)
}
export default Home;